// extracted by mini-css-extract-plugin
export default {"alertWrapper":"MultiActionFailureAlert_alertWrapper__n4uH6"};